import { Play } from "lucide-react";
import { StatusPill } from "./StatusPill";
import { OutputView } from "./OutputView";

export const ConnectorCard = ({ card, meta, state, onRun, email, setEmail, index }) => {
  const id = `card-${card.key}`;
  const r = state.result;
  const running = state.status === "RUNNING";
  return (
    <article data-testid={id} className="card" style={{ animationDelay: `${index * 40}ms` }}>
      <header className="flex items-start justify-between gap-3">
        <div>
          <div className="card-num">{String(card.n).padStart(2, "0")}</div>
          <h3 className="card-title">{card.title}</h3>
          <p className="card-prompt">{card.prompt}</p>
        </div>
        <StatusPill status={state.status} testId={`${id}-status`} />
      </header>

      <dl className="card-meta">
        <div><dt>provider</dt><dd data-testid={`${id}-provider`}>{r?.provider || meta?.provider || "—"}</dd></div>
        <div><dt>model</dt><dd data-testid={`${id}-model`}>{r?.model || meta?.model || "—"}</dd></div>
        <div><dt>latency</dt><dd data-testid={`${id}-latency`}>{r ? `${r.latency_ms} ms` : "—"}</dd></div>
        <div><dt>http</dt><dd data-testid={`${id}-http`}>{r ? (r.http_status ?? "n/a") : "—"}</dd></div>
      </dl>

      {card.key === "email" && (
        <input
          data-testid="email-recipient-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="field"
        />
      )}

      <div className="card-body">
        <OutputView k={card.key} output={r?.output} stream={state.stream} />
        {r?.error && <pre data-testid={`${id}-error`} className="out-error">{r.error}</pre>}
      </div>

      <button data-testid={`${id}-run-btn`} onClick={onRun} disabled={running} className="btn-run">
        <Play size={13} /> {running ? "Running" : "Run"}
      </button>
    </article>
  );
};
